import { DEFAULT_SCHEDULE_ORDER_BY } from 'common-data-handling';
import _, { identity } from 'lodash';
import { useMemo } from 'react';
import { isUpcomingSession } from '../../filters/scheduleFilters';
import { useEventSchedule } from './useEventSchedule';

/**
 * Selects upcoming sessions for an event (not started yet)
 * @param  {array}      sessions    all sessions stored
 * @param  {Number}     count       Max number of sessions being returned. Default = 1
 * @param  {function}   filter      Extra filter to be applied to all sessions
 * @param  {array}      orderBy      List of functions to use to sort before slicing
 * @return {array}      Sessions found
 */
export function selectUpcomingSessions(sessions = [], { count = 1, filter = identity, orderBy = DEFAULT_SCHEDULE_ORDER_BY } = {}) {
    return _(sessions)
        .filter((session) => isUpcomingSession(session))
        .filter(filter)
        .sortBy(orderBy)
        .slice(0, count)
        .value();
}

export function useUpcomingSessions(eventId, { count, filter, orderBy } = {}) {
    const sessions = useEventSchedule(eventId);
    return useMemo(() => selectUpcomingSessions(sessions, { count, filter, orderBy }), [sessions, count, filter, orderBy]);
}
